var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.297,
    height: 23.12,
    viewBox: "0 0 18.297 23.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#237bdf;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M256.63,421c.145.044.288.1.434.132a4.833,4.833,0,1,1-2.634.1c.233-.075.465-.155.7-.233Zm3.13,4.827a3.847,3.847,0,1,0-3.856,3.841A3.85,3.85,0,0,0,259.76,425.826Z",
    transform: "translate(-246.776 -420.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M222.863,525.321q-4.131,0-8.262,0c-.779,0-.864-.073-.848-.867a39.331,39.331,0,0,1,.163-4.955,7.952,7.952,0,0,1,7.619-6.663,18.186,18.186,0,0,1,4.3.25,8.027,8.027,0,0,1,6.2,7.789c.015,1.213.006,2.427,0,3.64,0,.7-.1.8-.8.805Q227.051,525.324,222.863,525.321Zm8.18-.985c0-1.341.085-2.633-.017-3.911a6.961,6.961,0,0,0-4.174-6c-1.312-.64-1.3-.608-2.106.581a1.33,1.33,0,0,0-.171,1.278c.4,1.264.736,2.549,1.124,3.818a.755.755,0,0,1-.219.874q-1.05.993-2.064,2.022c-.353.358-.657.4-1.027.017q-1.011-1.032-2.067-2.019a.8.8,0,0,1-.229-.927c.32-1.028.527-2.1.92-3.095a2.357,2.357,0,0,0-.4-2.635.632.632,0,0,0-.81-.263,7.384,7.384,0,0,0-3.995,3.064c-1.472,2.231-1.05,4.725-1.1,7.194Zm-9.65-10.552a11.6,11.6,0,0,0,.65,1,1.336,1.336,0,0,1,.205,1.388c-.4,1.243-.743,2.505-1.087,3.766a.721.721,0,0,0,.066.561c.483.594,1.008,1.155,1.626,1.85.613-.666,1.056-1.2,1.557-1.67a.719.719,0,0,0,.206-.856c-.4-1.305-.784-2.614-1.131-3.934a1.356,1.356,0,0,1,.116-.846,12.666,12.666,0,0,1,.776-1.261Z",
    transform: "translate(-213.751 -502.202)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.21182a4731a1e43e21a3a523aa4b89d4.svg";
export { ForwardRef as ReactComponent };